var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0658 13.7719L12.2268 10.932C14.351 8.09355 13.7718 4.0706 10.9331 1.94655C8.09441 -0.177504 4.07113 0.401656 1.9469 3.24013C-0.177331 6.07861 0.401877 10.1016 3.24059 12.2256C5.52088 13.9318 8.65281 13.9318 10.9331 12.2256L13.7733 15.0655C14.1302 15.4224 14.7088 15.4224 15.0657 15.0655C15.4226 14.7086 15.4226 14.13 15.0657 13.7732L15.0658 13.7719ZM7.11053 11.6775C4.58761 11.6775 2.54241 9.63245 2.54241 7.10974C2.54241 4.58704 4.58761 2.54201 7.11053 2.54201C9.63344 2.54201 11.6786 4.58704 11.6786 7.10974C11.676 9.6313 9.63233 11.6748 7.11053 11.6775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSearch);
export default __webpack_public_path__ + "static/media/WhiteSearch.969b39c3f20355cf33faf4bf77bbc500.svg";
export { ForwardRef as ReactComponent };